import { addressFormFieldsSX } from '@/components/blocks/AddressForm/styles/fields';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';
import { REG_EX } from '@/utils/address';
import { Divider, Stack } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleOauthClientId } from '@/data/Content/GoogleOauthClientId';
import { useElementWidth } from '@/utils/useElementWidth';
import { useId } from 'react';

type Props = {
	logonId: string;
	logonIdError?: string;
	disabled?: boolean;
	showInDialog?: boolean;
	onBlurLogonId: () => void;
	onChangeLogonId: (logonId: string) => void;
	onSubmitInitialLogonId: () => void;
	onGoogleLogin?: (idToken: string) => void;
};

export const InitialLogonIdStage: React.FC<Props> = ({
	logonId,
	logonIdError,
	disabled,
	showInDialog,
	onBlurLogonId,
	onChangeLogonId,
	onSubmitInitialLogonId,
	onGoogleLogin,
}) => {
	const { googleOauthClientId } = useGoogleOauthClientId();
	const uid = useId().replace(/:/g, '');
	const emailInputId = `email-sign-in-submit-${uid}`;
	const submitButtonId = `button-sign-in-submit-${uid}`;
	const googleButtonWidth = useElementWidth(`#${submitButtonId}`);

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			onSubmitInitialLogonId();
		}
	};

	return (
		<Stack width="100%" flex={1}>
			<DpOutlinedInput
				sx={{
					...addressFormFieldsSX,
					'.MuiOutlinedInput-input': {
						padding: '14px 14px',
						fontSize: 'var(--font-size-body)',
						height: '20px',
					},
				}}
				variant="outlined"
				fullWidth
				required
				name="email"
				autoComplete="email"
				id={emailInputId}
				label="Correo electrónico"
				error={!!logonIdError}
				helperText={logonIdError}
				value={logonId}
				InputLabelProps={{
					sx: {
						fontSize: 'var(--font-size-body)',
						lineHeight: '1',
					},
				}}
				inputProps={{
					maxLength: 100,
					type: 'email',
					pattern: REG_EX.EMAIL.source,
				}}
				FormHelperTextProps={{
					sx: { ml: '3px' },
				}}
				onChange={(e) => onChangeLogonId(e.target.value)}
				onKeyDown={handleKeyDown}
				onBlur={onBlurLogonId}
			/>

			<DpButton
				sx={showInDialog ? { height: '44px', mt: '20px' } : { mt: '20px' }}
				id={submitButtonId}
				disabled={disabled}
				onClick={onSubmitInitialLogonId}
			>
				{'Continuar'}
			</DpButton>

			{googleOauthClientId && onGoogleLogin ? (
				<Stack mt="20px" spacing="16px" width="100%">
					<Divider sx={{ color: 'var(--color-text-disabled)', fontSize: 'var(--font-size-small)' }}>
						{'o'}
					</Divider>
					<Stack alignItems="center" width="100%">
						<GoogleLogin
							text="continue_with"
							theme="outline"
							shape="pill"
							width={googleButtonWidth ? String(googleButtonWidth) : undefined}
							onSuccess={(credentialResponse) => {
								if (credentialResponse.credential) {
									onGoogleLogin(credentialResponse.credential);
								}
							}}
						/>
					</Stack>
				</Stack>
			) : null}
		</Stack>
	);
};
